export const getRefId = (value) => value?._id || value

export const isApproverOrDelegatee = (approverDetail, userId) => {
  const approverUserId = getRefId(approverDetail?.user)
  const delegateeUserId = getRefId(approverDetail?.delegationDetail?.delegatee)
  return approverUserId === userId || delegateeUserId === userId
}

// Same user can simultaneously hold more than one approver/delegatee slot (e.g. two
// levels, or approver on one level and delegatee on another). Returns every slot that
// matches instead of only the first one.
export const findApproverSlots = (approverDetails, userId, allowedStatuses) => {
  if (!Array.isArray(approverDetails) || !userId) {
    return []
  }

  return approverDetails.reduce((slots, detail, approverIndex) => {
    if (isApproverOrDelegatee(detail, userId) && allowedStatuses.includes(detail?.status)) {
      slots.push({ approverIndex, detail })
    }
    return slots
  }, [])
}

// Same as findApproverSlots, but for the invitee side: every approver slot where this
// user has a still-pending ('Invited') invitation.
export const findInviteeSlots = (approverDetails, userId) => {
  if (!Array.isArray(approverDetails) || !userId) {
    return []
  }

  return approverDetails.reduce((slots, detail, approverIndex) => {
    const invitedUsers = Array.isArray(detail?.invitedUsers) ? detail.invitedUsers : []
    const inviteeIndex = invitedUsers.findIndex(
      (invitee) => getRefId(invitee?.user) === userId && invitee?.status === 'Invited'
    )

    if (inviteeIndex >= 0) {
      slots.push({ approverIndex, inviteeIndex, detail, invitee: invitedUsers[inviteeIndex] })
    }

    return slots
  }, [])
}

export const formatApproverSlotLabel = (detail) => {
  if (!detail) {
    return 'Approver'
  }

  if (typeof detail.level === 'number') {
    const roleLabel = detail.type === 'commercial' ? 'Commercial' : 'Technical'
    return `Level ${detail.level} ${roleLabel}`
  }

  return detail.type || 'Approver'
}
